import { Typography } from '@mui/material';
import Grid from '@mui/material/GridLegacy';
import { styled } from '@mui/material/styles';
import React from 'react';
import ImageComponent from '../Image';
import type { IconCardProps } from './IconCard.types';

const PREFIX = 'IconCard';

const classes = {
  root: `${PREFIX}-root`,
  item: `${PREFIX}-item`,
  description: `${PREFIX}-description`,
};

const StyledGrid = styled(Grid)<IconCardProps>(({ theme, card }) => ({
  paddingTop: 10,
  paddingBottom: 10,

  [`& .${classes.item}`]: {
    height: '100%',
    width: card?.image?.width,
  },

  [`& .${classes.description}`]: {
    top: '50%',
    transform: 'translateY(15%)',
    paddingLeft: 10,
    [theme.breakpoints.down('lg')]: {
      paddingLeft: 0,
      paddingTop: 20,
    },
  },
}));

export const IconCard: React.FC<IconCardProps> = ({ card }) => {
  return (
    <StyledGrid
      card={card}
      item
      xs={card?.xs}
      sm={card?.sm}
      md={card?.md}
      lg={card?.lg}>
      <Grid container className={classes.root}>
        <Grid item xs={12} sm={12} md={12} lg={2} className={classes.item}>
          {card?.image && <ImageComponent model={card?.image} />}
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={8}
          className={classes.description}>
          <Typography variant="h3">{card?.title}</Typography>
          <Typography>{card?.description}</Typography>
        </Grid>
      </Grid>
    </StyledGrid>
  );
};
